import getAllTableViewsContainingItemsForFolder from '../utils/getAllTableViewsContainingItemsForFolder';
import getTableConversationRelation from 'mini-mail-list-store/lib/utils/getTableConversationRelation';
import isItemView from 'mini-mail-list-store/lib/utils/isItemView';
import type ItemContext from 'owa-mail-store/lib/store/schema/ItemContext';
import removeRowsFromListViewStoreInternal from './triage/removeRowsFromListViewStoreInternal';
import removeSingleItemFromConversation from './triage/removeSingleItemFromConversation';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';

/**
 * Deletes item/conversation from all table views in the list view store
 * @param itemContexts the items/conversation ids to be deleted
 * @param parentFolderId
 */
export default function deleteItemsStoreUpdateList(
    itemContexts: ItemContext[],
    parentFolderId: string
) {
    const tableViews = getAllTableViewsContainingItemsForFolder(
        parentFolderId,
        true /*shouldIncludeSearchTable*/
    );
    for (const tableView of tableViews) {
        if (isItemView(tableView)) {
            removeItemsInMessageTable(itemContexts, tableView);
        } else {
            removeItemsInConversationTable(itemContexts, tableView);
        }
    }
}

/**
 * Remove itemIds from given tableView.
 * @param itemContexts itemContexts of itemIds to be removed.
 * @param tableView tableView from which itemData needs to be removed.
 *
 */
function removeItemsInMessageTable(itemContexts: ItemContext[], tableView: TableView): void {
    const filteredItemIds: string[] = itemContexts
        .map(itemContext => itemContext.itemId)
        .filter(itemId => tableView.itemIds.indexOf(itemId) >= 0);

    if (!(filteredItemIds && filteredItemIds.length)) {
        return;
    }

    removeRowsFromListViewStoreInternal(filteredItemIds, tableView);
}

/**
 * Remove conversation node from list view store
 * @param itemContext contains the conversation id and item id of the conversation node
 * @param tableView is the source table view to delete from
 */
function removeItemsInConversationTable(itemContexts: ItemContext[], tableView: TableView) {
    for (const itemContext of itemContexts) {
        const tableConversationRelation = getTableConversationRelation(
            itemContext.conversationId,
            tableView.id
        );
        if (!tableConversationRelation) {
            // This item was not found in the current table, noop
            continue;
        }

        if (
            tableConversationRelation.itemIds.length === 1 &&
            tableConversationRelation.itemIds[0] === itemContext.itemId
        ) {
            // Removing the last item in the conversation, we need to remove the entire conversation row
            removeRowsFromListViewStoreInternal([itemContext.conversationId], tableView);
        } else {
            removeSingleItemFromConversation(itemContext, tableView.id);
        }
    }
}
